import { ALPHA_EQUAL_A_ZERO } from "../constants";

export const berechneQuerschnittsnachweis = (
  bemessungswertDruckkraft,
  normalkrafttragfaehigkeit,
  biegemomentdesPfahls,
  elastischeMomententragfaehigkeit
) => {
  return (
    Number(bemessungswertDruckkraft) / Number(normalkrafttragfaehigkeit) +
    Number(biegemomentdesPfahls) / Number(elastischeMomententragfaehigkeit)
  );
};

export const berechneVerformungsbegrenzung = (
  verformungsamplitude,
  elastischerBereichDerSeitlichenBettung
) => {
  return Number(verformungsamplitude) / Number(elastischerBereichDerSeitlichenBettung);
};

export const berechnePhi = (bezogenerSchlankheitsgrad) => {
  return (
    0.5 *
    (1 +
      Number(ALPHA_EQUAL_A_ZERO) * (bezogenerSchlankheitsgrad - 0.2) +
      Math.pow(bezogenerSchlankheitsgrad, 2))
  );
};

export const berechneAbminderungsfaktor = (phi_calc, bezogenerSchlankheitsgrad) => {
  return (
    1 /
    (Number(phi_calc) +
      Math.sqrt(Math.pow(Number(phi_calc), 2) - Math.pow(Number(bezogenerSchlankheitsgrad), 2)))
  );
};

export const berechneBiegeknickbeanspruchbarkeit = (
  abminderungsfaktor,
  querschnitt,
  charakteristischeFestigkeit,
  teilsicherheitsbeiwert
) => {
  return (abminderungsfaktor * querschnitt * charakteristischeFestigkeit) / teilsicherheitsbeiwert;
};

export const berechneAusnutzung = (bemessungslast, biegeknickbeanspruchbarkeit) => {
  return bemessungslast / biegeknickbeanspruchbarkeit;
};

export const berechneKnicken = (props) => {
  const { knickkoeffizient, traggliedDaten, dickeWeicheBodenschicht } = props;

  // zuvor E
  let elastizitaetsmodul =
    Number(traggliedDaten?.knicken.dehnsteifigkeit) / Number(traggliedDaten?.querschnitt);

  // zuvor Dcal
  let aussendurchmesser = Math.sqrt(
    (4 * traggliedDaten?.querschnitt) / Math.PI +
      Math.pow(traggliedDaten?.knicken.innendurchmesser, 2)
  );

  // zuvor I
  let traegheitsmoment =
    (Math.PI / 64) *
    (Math.pow(aussendurchmesser, 4) - Math.pow(traggliedDaten?.knicken.innendurchmesser, 4));

  // zuvor Lcr
  let kritischeKnicklaenge = dickeWeicheBodenschicht * 1_000 * knickkoeffizient;
  // zuvor i_root
  let traegheitsradius = Math.sqrt(traegheitsmoment / traggliedDaten?.querschnitt);

  // zuvor fyk
  let charakteristischeFestigkeit =
    Number(traggliedDaten?.max_charakteristische_tragfaehigkeit) /
    Number(traggliedDaten?.querschnitt);

  let bezugsschlankheitsgrad =
    Math.PI * Math.sqrt(elastizitaetsmodul / charakteristischeFestigkeit);
  let bezogenerSchlankheitsgrad =
    kritischeKnicklaenge / (traegheitsradius * bezugsschlankheitsgrad);

  // zuvor Ws
  let widerstandsmoment =
    (Math.PI / 32) *
    ((Math.pow(aussendurchmesser, 4) - Math.pow(traggliedDaten?.knicken.innendurchmesser, 4)) /
      aussendurchmesser);

  return {
    traggliedDaten,
    elastizitaetsmodul,
    aussendurchmesser,
    traegheitsmoment,
    kritischeKnicklaenge,
    traegheitsradius,
    bezugsschlankheitsgrad,
    bezogenerSchlankheitsgrad,
    charakteristischeFestigkeit,
    widerstandsmoment,
  };
};
